import { useState, useEffect } from 'react'
import type { NetworkStatus } from '@/types'

export function useNetworkStatus(): NetworkStatus {
  const [status, setStatus] = useState<NetworkStatus>(
    navigator.onLine ? 'online' : 'offline'
  )

  useEffect(() => {
    const online  = () => setStatus('online')
    const offline = () => setStatus('offline')

    window.addEventListener('online',  online)
    window.addEventListener('offline', offline)

    // Detect slow connection via Network Information API (where supported)
    const conn = (navigator as any).connection
    if (conn) {
      const update = () => {
        if (!navigator.onLine) { setStatus('offline'); return }
        const slow = conn.effectiveType === '2g' || conn.effectiveType === 'slow-2g'
        setStatus(slow ? 'slow' : 'online')
      }
      conn.addEventListener('change', update)
      update()
      return () => {
        window.removeEventListener('online',  online)
        window.removeEventListener('offline', offline)
        conn.removeEventListener('change', update)
      }
    }

    return () => {
      window.removeEventListener('online',  online)
      window.removeEventListener('offline', offline)
    }
  }, [])

  return status
}
